import { render } from "./PageStripes.vue?vue&type=template&id=0aa1ed32&scoped=true"
import script from "./PageStripes.vue?vue&type=script&lang=js"
export * from "./PageStripes.vue?vue&type=script&lang=js"

import "./PageStripes.vue?vue&type=style&index=0&id=0aa1ed32&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa1ed32"]])

export default __exports__